import React from "react";
import {
    DataGrid,
    HeaderFilter,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager,
    Lookup,
    Format,
    FormItem,
    Sorting,
    Button as GridButton,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label, ButtonItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarAliquotaIPTUDs, criarNumeroComplementoConferencia, opcoesFatoresDs } from "../DataSources";
import UserInfo from "../UserInfo";
import react from "react";
import api from "../api-axios";

export default class ConferenciaNumeroComplemento extends React.Component {
    constructor() {
        super();
        this.dataGrid = react.createRef();
        this.dataSource = criarNumeroComplementoConferencia();
        this.initNewRow = this.initNewRow.bind(this);
        this.naturezasDataSource = [
            { id: "T", descricao: "Territorial" },
            { id: "E", descricao: "Edificado" }
        ];
        this.state = {
            filtro: {
                distrito: 1,
                setor: 99,
                quadra: 999
            }
        };
        this.carregar = this.carregar.bind(this);
        this.aplicar = this.aplicar.bind(this);
    }

    carregar() {
        const novoFiltro = [];
        if (this.state.filtro.distrito && this.state.filtro.distrito != 0) {
            novoFiltro.push(["distrito", "=", this.state.filtro.distrito]);
        }

        if (this.state.filtro.setor && this.state.filtro.setor != 0) {
            novoFiltro.push(["setor", "=", this.state.filtro.setor]);
        }

        if (this.state.filtro.quadra && this.state.filtro.quadra != 0) {
            novoFiltro.push(["quadra", "=", this.state.filtro.quadra]);
        }

        this.dataGrid.instance.filter(novoFiltro);
        this.dataGrid.instance.refresh();
    }

    async aplicar() {
        const prefeituraId = UserInfo.getPrefeitura();

        try {
            const filtro = this.state.filtro;
            const distrito = filtro.distrito ?? 0;
            const setor = filtro.setor ?? 0;
            const quadra = filtro.quadra ?? 0;

            await api.post(`conferencia_numero_complemento/aplicar/${prefeituraId}/${distrito}/${setor}/${quadra}`);

        }
        catch (error) {
            console.log(error);
        }
        finally{
            this.dataGrid.instance.refresh();
        }
    }


    render() {

        const podeEditarDistrito = this.state.filtro.distrito == null || this.state.filtro.distrito == undefined || this.state.filtro.quadra == 0;
        const podeEditarSetor = this.state.filtro.setor == null || this.state.filtro.setor == undefined || this.state.filtro.setor == 0;
        const podeEditarQuadra = this.state.filtro.quadra == null || this.state.filtro.quadra == undefined || this.state.filtro.quadra == 0;






        return (

            <div className={'content-block dx-card responsive-paddings'}>
                <form onSubmit={this.filtrar}>
                    <Form id="frmPesquisa" formData={this.state.filtro} colCount={5}>
                        <SimpleItem
                            dataField="distrito"
                            editorType={"dxNumberBox"}
                            colSpan={1}
                            editorOptions={{ step: 0 }}
                        >
                            <Label text="Distrito" />
                        </SimpleItem>
                        <SimpleItem
                            dataField="setor"
                            editorType={"dxNumberBox"}
                            colSpan={1}
                            editorOptions={{ step: 0 }}
                        >
                            <Label text="Setor" />
                        </SimpleItem>
                        <SimpleItem
                            dataField="quadra"
                            editorType={"dxNumberBox"}
                            colSpan={1}
                            editorOptions={{ step: 0 }}
                        >
                            <Label text="Quadra" />
                        </SimpleItem>
                        <ButtonItem buttonOptions={{ text: "Carregar", type: "success", width: "100%", onClick: this.carregar }} />
                        <ButtonItem buttonOptions={{ text: "Aplicar", type: "default", width: "100%", onClick: this.aplicar }} />
                    </Form>
                </form>
                <br /> <br />
                <PaginaToolbar titulo="CONFERÊNCIA NÚMERO/COMPLEMENTO">
                    <DataGrid
                        dataSource={this.dataSource}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        columnAutoWidth={true}
                        onInitNewRow={this.initNewRow}
                        keyExpr={"id"}
                        ref={(e) => this.dataGrid = e}>


                        <Editing allowUpdating={true} allowEditing={true} useIcons={true} allowDeleting={true} />

                        <Column
                            type="buttons"
                            fixed={true}
                            fixedPosition={"right"}
                            buttons={[
                                "edit",
                                "delete"
                            ]}
                        />

                        <Column dataField={"id"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>

                        <Column dataField={'distrito'} caption={"Dis"} width={70} alignment={"center"} sortIndex={0} sortOrder={"asc"} allowEditing={podeEditarDistrito} />
                        <Column dataField={'setor'} caption={"Set"} width={70} alignment={"center"} sortIndex={1} sortOrder={"asc"} allowEditing={podeEditarSetor} />
                        <Column dataField={'quadra'} caption={"Qda"} width={90} alignment={"center"} sortIndex={2} sortOrder={"asc"} allowEditing={podeEditarQuadra} />
                        <Column dataField={'lote'} caption={"Lote"} width={90} alignment={"center"} sortIndex={3} sortOrder={"asc"} />
                        <Column dataField={'unidade'} caption={"Und"} width={90} alignment={"center"} sortIndex={4} sortOrder={"asc"} />

                        <Column dataField={'numeroOriginal'} caption={"Nº Orig."} allowEditing={false} width={150} visible={false} />
                        <Column dataField={'complementoOriginal'} caption={"Complemento Orig."} allowEditing={false} visible={false} />

                        <Column dataField={'numero'} caption={"Nº"} width={150} />
                        <Column dataField={'complemento'} caption={"Complemento"} />

                        <Column dataField={'status'} caption={"Status"} allowEditing={false} width={120} alignment={"center"} />

                        <Column dataField={'msgErro'} caption={"Erro"} visible={false} />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
        e.data.distrito = this.state.filtro.distrito;
        e.data.setor = this.state.filtro.setor;
        e.data.quadra = this.state.filtro.quadra;
        e.data.status = "PENDENTE";
        console.log(e);
    }
}